import { useEffect, useState } from "react";
import { Tabs, Tab } from "react-bootstrap"
import { sbaAxios } from "../utils/sbaAxios";
import { getServiceHealth, getServiceHealthTypes,getServiceStatusKeys } from "../../config/apiConfig";
import DialControl from "../UiComponents/DialControl";
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/system';
import moment from "moment";

export const Services = () => {
    const [key, setKey] = useState('ServicesHealth');
    const [servicesHealth, setServicesHealth] = useState([]);
    useEffect(()=>{
        FetchServicesHealthTypes();
    },[])
    const FetchServicesHealthTypes = () => {
        sbaAxios({ url: getServiceHealthTypes }).then(res => {
            setServicesHealth(val => {
                const updatedServices = res.map(item => ({
                    ...item,
                    isActive: item.ServiceTypeId==-1
                }));
                return updatedServices;
            })
        }).catch(error => {
            console.log(error, 'Error While Fetching the Service Health')
        })
    };
   
    return (
        <div>
            <Tabs
                activeKey={key}
                onSelect={(k) => setKey(k)}
                className="ms-4"
            >
                <Tab eventKey="ServicesHealth" title="Services Health">
                    <div className="p-3 bg-white life-science rounded">
                        <ServicesHealth Services={servicesHealth} setServices={setServicesHealth} />
                    </div>
                </Tab>
                {/* <Tab eventKey="ServiceKeyMetrics" title="Service Key Metrics" disabled>
                    <div className="p-3 bg-white life-science rounded">
                        Tab content for Service Key Metrics
                    </div>
                </Tab> */}
            </Tabs>
        </div>

    )
}
const ServicesHealth = ({ Services, setServices }) => {
    const [myServices, setMyServices] = useState([]);
    const [legendData, setLegendData] = useState([]);

    const FetchServiceHealth=(serviceTypeId)=>{
        const url=serviceTypeId ? getServiceHealth+"?serviceTypeId="+serviceTypeId :getServiceHealth;
        sbaAxios({url}).then(res=>{
            setMyServices(res);
        }).catch(error=>{
            console.log(error,'Error Fetching Service Health Types')
        })
    };

    const fetchLegendData = async() => {
        try{
            const list = await sbaAxios({
                url:getServiceStatusKeys
            });
            setLegendData(list.map((item) => {
                return {
                    color: item.StatusColorHex,
                    text: item.ServiceStaus
                }
            }));
        }
        catch(e){
            setLegendData([]);
        }
    };

    useEffect(() => {
        FetchServiceHealth(-1)
        fetchLegendData();
    }, []);

    const formatDateTime = (dateTimeString) => {
        const date = new Date(dateTimeString);
        const formattedDate = date.toLocaleDateString('en-US'); // MM/DD/YYYY
        const formattedTime = date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true }); // hh:mm AM/PM
        return `${formattedDate} @ ${formattedTime}`;
    };

    // const legendData = [
    //     { color: '#FF5733', text: 'High Risk Area' },
    //     { color: '#33FF57', text: 'Safe Zone' },
    //     { color: '#3357FF', text: 'Moderate Risk Area' },
    // ];

    return <> <div>
        <div className="button-container">
            {Services?.map(option=> (
                <button
                    key={option.ServiceTypeId}
                    className={`non-gappable-button  ${option.isActive
                        ? "selected-non-gappable-button"
                        : ""
                        }`}
                    disabled={option?.disabled}
                    onClick={() => {
                        setServices(res => {
                            const updatedServices = res.map(item => ({
                                ...item,
                                isActive: item.ServiceTypeId === option.ServiceTypeId
                            }));
                            return updatedServices;
                        });
                        FetchServiceHealth(option.ServiceTypeId)
                    }}
                >
                    {option.ServiceName}    ({option.ServiceCount})
                </button>
            ))}
        </div>
        {/* <div className="p-4">
            {myServices.map(item => (<span className="p-3 SBA_hand" title={"Last Run Date:" + moment(item.AsOfDate).format('MM/DD/YYYY')}>
                <DialControl name={item.ServiceName} color={item.StatusColorHex} value={100} style={{ marignInline: "4px" }} />
            </span>))}
        </div> */}
        <div className="row mt-3">
            <Legend items={legendData} />
        </div>
        <div className="p-4">
            {myServices.map(item => (
                <CustomTooltip
                    key={item.ServiceName}
                    title={
                        <div style={{ textAlign: "left" }}>
                            <div><span style={{fontWeight:'bold'}}>Last Run Date:</span> {formatDateTime(item.AsOfDate)}</div>
                            <div><span style={{fontWeight:'bold'}}>Server Name:</span> {item.ServerName}</div>
                            <div><span style={{fontWeight:'bold'}}>Service Description:</span> {item.ServiceDescription}</div>
                            <div><span style={{fontWeight:'bold'}}>Service Schedule:</span> {item.ServiceSchedule}</div>
                        </div>
                    }
                >
                    <span className="p-3 SBA_hand">
                        <DialControl name={item.ServiceName} color={item.StatusColorHex} value={100} style={{ marignInline: "4px" }} />
                    </span>
                </CustomTooltip>
            ))}
        </div>
    </div>
    </>
};

const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))({
    '& .MuiTooltip-tooltip': {
        backgroundColor: 'white', // Solid white background
        color: 'black', // Black text
        fontSize: '1rem', // Bigger font size
        border: '2px solid black', // Black border
        padding: '10px', // Padding around the text
    },
    '& .MuiTooltip-arrow': {
        display: 'none', // Hides the arrow
    },
});

const LegendItem = ({ color, text }) => {
    const ringStyle = {
        width: '20px',
        height: '20px',
        border: `4px solid ${color}`,
        borderRadius: '50%',
        display: 'inline-block',
        marginRight: '8px',
    };

    return (
        <div style={{ display: 'flex', alignItems: 'center', marginRight: '16px' }}>
            <span style={ringStyle}></span>
            <span style={{ fontSize: '1rem', color: '#333' }}>{text}</span>
        </div>
    );
};

const Legend = ({ items }) => (
    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        {items.map((item, index) => (
            <LegendItem key={index} color={item.color} text={item.text} />
        ))}
    </div>
);